window.downloadLatestVersion = function () {
  window.lmcPlayer
    .downloadPlayer()
    .then(() => {})
    .catch((error) => { console.error(error)});
}

window.openInstallPlayer = function (anchor) {

  if (jQuery(anchor).data('svod_film_id')) {
    jQuery.ajax({
      dataType: "json",
      url: Routing.generate('uc_fo_svod_check_film', {filmId: jQuery(anchor).data('svod_film_id')}),
    }).success(function (response) {
      if (response.isUserFilmSvodAllowed) {
        jQuery('#splashDownloadModal1').modal();
      } else {
        alert("Une erreur s'est produite, merci d'essayer de nouveau ou contacter l'assistance.");
      }
    });
  } else {
    jQuery('#splashDownloadModal1').modal();
  }
}

window.openPlayer = function () {
  document.querySelector('.loading-centered').classList.remove('hidden');
  window.lmcPlayer
    .openPlayer()
    .then((status) => {
      document.querySelector('.loading-centered').classList.add('hidden');
      console.log("player open status:", status);
      if (status === false) {
        console.log('Veuillez installer le player');
        jQuery('#splashDownloadModal1').modal();
      }
    })
    .catch((error) => { console.error(error)});
}

window.openPlayerWithAuth = function (authToken) {
	document.querySelector('.loading-centered').classList.remove('hidden');
    window.lmcPlayer
    .openPlayer(authToken)
    .then((status) => {
      document.querySelector('.loading-centered').classList.add('hidden');
      console.log("player open status:", status);
      if (status === false) {
        console.log('Veuillez installer le player');
        jQuery('#splashDownloadModal1').modal();
      }
    })
    .catch((error) => { console.error(error)});
}

window.openPlayerWithDl = function (authToken, videoId, url, availId) {
	document.querySelector('.loading-centered').classList.remove('hidden');

    jQuery.ajax({
        type: 'POST',
        data: {
            'productUuid': videoId,
            'availId': availId
        },
        url: url,
        success: function (response) {
            console.log(response);
            window.lmcPlayer
                .openPlayer(authToken, response.productUuid)
                .then((status) => {
                    document.querySelector('.loading-centered').classList.add('hidden');
                    console.log("player open status:", status);
                    if (status === false) {
                        console.log('Veuillez installer le player');
                        jQuery('#splashDownloadModal1').modal();
                    }
                })
                .catch((error) => { console.error(error)});
        },
        error: function () {
            window.lmcPlayer
                .openPlayer(authToken, videoId)
                .then((status) => {
                    document.querySelector('.loading-centered').classList.add('hidden');
                    console.log("player open status:", status);
                    if (status === false) {
                        console.log('Veuillez installer le player');
                        jQuery('#splashDownloadModal1').modal();
                    }
                })
                .catch((error) => { console.error(error)});
        }
    });
}


document.addEventListener("DOMContentLoaded", initApp);
